import React from 'react';
import PropTypes from 'prop-types';

class Loadable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Component: null,
      error: null,
      isLoading: true,
      isLoaded: false,
      isError: false
    };
  }

  componentDidMount() {
    this.props.loader().then(
      module => {
        this.setState({
          Component: module.default,
          isLoading: false,
          isLoaded: true
        });
      },
      error => {
        this.setState({
          error,
          isLoading: false,
          isError: true
        });
      }
    );
  }

  render() {
    const { isLoading, isLoaded, isError, Component, error } = this.state;

    if (isLoading) {
      return this.props.loading();
    }

    if (isError) {
      return this.props.error(error);
    }

    if (isLoaded) {
      return this.props.render(Component);
    }

    return null;
  }
}

Loadable.defaultProps = {
  loading: () => null,
  error: () => null
};

Loadable.propTypes = {
  loader: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  loading: PropTypes.func,
  error: PropTypes.func
};

export default Loadable;
